//FB 9639
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { Message, Recipient } from "../../../../store"; //FB 9639
import useStyles from "../../../../css/styles";
import { InsertPPLogs, GetMessageReplies } from "../../../../api";//FB 10088
import { Box, Grid, IconButton } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useEffect, useState } from "react";  //FB 9639
import useMediaQuery from "@mui/material/useMediaQuery";
// FB 7074 Begin
import { useNavigate } from "react-router-dom";
import ReplyIcon from "@mui/icons-material/Reply"; // FB 7074 End

// Update log
// FB  6192   02/06/2023  DK   Added page to handle inbox messages
// FB  7074   07/21/2023  SK   Patient Portal : Develop the feature of message reply
// FB  7579   10/13/2023  DK  no messages when you login to portal on phone
// FB  8934   09/30/2024  GS  Staff should not have Dr in front of it
// FB  9639   12/02/2024  DK  Employee Groups that are Set to be Portal Addressees.
// FB  10088   05/15/2025  GS  Allow to send the message from EMR to portal only

export default function Inbox(props: any) {
  const matches = useMediaQuery("(min-width:600px)");
  const styles = useStyles();
  //FB 9639
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsArray, setRowsArray] = useState([5, 10, 15, 20]);
  const [isAllowReplies, setAllowReplies] = useState(true);//FB 10088

  //FB 7074 - Begin
  const navigate = useNavigate();
  const ReplyToMessage = async (ID: any) => {
    sessionStorage.setItem("MessageID", ID);
    navigate("/user/home/Reply", { state: props.recipients });  //FB 9639  
  };
  //FB 7074 - End

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const stylestop = {
    container: {
      // width: matches == false ? "250" : "567px",
      border: "1px grey",
      backgroundColor: "white",
      padding: matches == false ? "32px 16px 0px 16px" : "32px 40px",
      marginBottom: matches == false ? "150px" : "0px",
      height: "206px",
    },
  };

  //FB 9639 Start
  function GetPhysicianName(ID: number, Is_Group_Message: boolean) {
    if (props.recipients != null || props.recipients != undefined) {
      let recipient = props.recipients.filter((rcp: any) => rcp.Is_Group == Is_Group_Message).find(
        (rcp: any) => rcp.ID == ID
      ) as Recipient;
      let recipientName = recipient != undefined && recipient != null ? recipient.Name : "";
      return recipientName;
    }
  }
  //FB 9639 End

  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  async function InsertLogs() {
    InsertPPLogs("Viewing Inbox Messages", window.location.href, userName, "");
  }

  //FB 9639
  useEffect(() => {
    InsertLogs();
    GetMessageReplies().then(setAllowReplies);//FB 10088
  }, []);

  return (
    // FB 7579
    <div style={{ marginTop: matches == false ? "16px" : "90px", marginBottom: "20px" }}>
      {props.messages != null ? (
        <>
          {/* FB 7579 */}
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ height: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableBody>
                  {props.messages
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    .map((message: Message) => {
                      return (
                        <TableRow>
                          <div
                            className="card-body"
                            style={{ marginTop: "30px" }}
                          >
                            <div className="row">
                              <div className="col">
                                {/* FB 9639 */}
                                <p
                                  style={{
                                    textAlign: "left",
                                    textTransform: "capitalize",
                                    color:
                                      message.IsRead === 0
                                        ? "#13607C"
                                        : "black",
                                  }}
                                >
                                  {/* FB 7074 - Begin */}
                                  {/* FB 10088 */}
                                  <strong
                                    style={{ 
                                      cursor: isAllowReplies ? "pointer" : "not-allowed", 
                                      opacity: isAllowReplies ? 1 : 0.5 
                                    }}
                                    onClick={isAllowReplies ? () => ReplyToMessage(message.ID) : undefined}
                                    title={isAllowReplies ? "Reply to Message" : "Replies are disabled"}
                                  >
                                    <ReplyIcon />
                                  </strong>
                                  <br />
                                  {/* FB 7074 - End */}
                                  {/* FB 9639 */}
                                  <strong>
                                    {GetPhysicianName(message.PhysicianID, message.Is_Group_Message)}
                                  </strong>
                                </p>
                              </div>
                              <div className="col">
                                <p
                                  style={{
                                    textAlign: "right",
                                    color:
                                      message.IsRead === 0
                                        ? "#13607C"
                                        : "black",
                                  }}
                                >
                                  <strong>
                                    {new Date(
                                      message.DateCreated
                                    ).toLocaleDateString() + ""}
                                  </strong>
                                </p>
                              </div>
                            </div>
                            <p
                              className="card-text"
                              style={{ textAlign: "left" }}
                            >
                              <strong>Subject: </strong>
                              {message.Subject}
                            </p>
                            <div
                              dangerouslySetInnerHTML={{ __html: message.Body }}
                            />
                          </div>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <Box
            sx={{
              flexGrow: 1,
              paddingTop: 2,
              paddingBottom: 2,
              maxWidth: "100%",
            }}
          >
            <Grid container>
              <Grid item xs={8} display="flex">
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                    <span className={styles.TablePagination_text}>Show </span>
                  </Grid>
                  <Grid item>
                    <select
                      value={rowsPerPage}
                      onChange={(e) => handleChangeRowsPerPage(e)}
                      style={{
                        color: "#083A4D",
                        borderRadius: "5px",
                        padding: "8px, 16px, 8px, 16px",
                      }}
                    >
                      {rowsArray.map((rows) => (
                        <option value={rows}>{rows}</option>
                      ))}
                    </select>
                  </Grid>
                  <Grid item>
                    <span className={styles.TablePagination_text}>
                      {" "}
                      per page
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} className={styles.flexend_Grid}>
                <IconButton
                  onClick={() => setPage(page - 1)}
                  disabled={page === 0}
                  style={{ color: page === 0 ? "" : "#083A4D" }}
                >
                  <PlayCircleOutlineIcon
                    style={{ transform: "rotate(180deg)" }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => setPage(page + 1)}
                  disabled={
                    page >=
                    Math.ceil(
                      (props.messages ? props.messages.length : 0) / rowsPerPage
                    ) -
                    1
                  }
                  style={{
                    color:
                      page >=
                        Math.ceil(
                          (props.messages ? props.messages.length : 0) /
                          rowsPerPage
                        ) -
                        1
                        ? ""
                        : "#083A4D",
                  }}
                >
                  <PlayCircleOutlineIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        <div className="col-sm-6" style={stylestop.container}>
          <label
            className="card-text"
            style={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              letterSpacing: "0em",
              textAlign: "left",
              paddingBottom: "91px",
              paddingTop: "52px",
              paddingLeft: matches == false ? "16px" : "40px",
              height: "24px",
              minHeight: "70vh",
            }}
          >
            When you receive messages, they will be shown here.
          </label>
        </div>
      )}
    </div>
  );
}
